import { ContentCourse, Question } from "../modules/lcms/content-courses/schemas/schemas";

// Convert JSON data to standard schema format
export const convertJsonToStandardQuestion = (jsonQuestion: any): Question => {
  return {
    question_id: jsonQuestion.question_id,
    question_text: jsonQuestion.question_text,
    question_type: jsonQuestion.question_type as 'multiple_choice' | 'fill_in_blank' | 'boolean' | 'text',
    options: jsonQuestion.options,
    correct_option: jsonQuestion.correct_option,
    correct_answer: jsonQuestion.correct_answer
  };
};

export const convertJsonToStandardCourse = (jsonCourse: any): ContentCourse => {
  const course: ContentCourse = {
    id: jsonCourse.id,
    name: jsonCourse.name,
    title: jsonCourse.title,
    description: jsonCourse.description,
    status: jsonCourse.status,
    createdAt: jsonCourse.createdAt,
    updatedAt: jsonCourse.updatedAt,
    author: jsonCourse.author,
    category: jsonCourse.category,
    tags: jsonCourse.tags,
    duration: jsonCourse.duration,
    requiredForCompletion: jsonCourse.requiredForCompletion,
    sequentialProgress: jsonCourse.sequentialProgress,
    level: jsonCourse.level,
    metadata: {
      createdBy: jsonCourse.createdBy || jsonCourse.author || 'System',
      tags: jsonCourse.tags,
      requiredForCompletion: jsonCourse.requiredForCompletion,
      sequentialProgress: jsonCourse.sequentialProgress,
      ...jsonCourse.metadata
    }
  };

  // Convert modules directly from JSON structure if available
  if (jsonCourse.modules) {
    course.modules = jsonCourse.modules.map((module: any) => ({
      module_id: module.module_id,
      name: module.name,
      type: module.type,
      sections: module.sections?.map((section: any) => ({
        section_id: section.section_id,
        name: section.name,
        order: section.order,
        delivery_method: section.delivery_method,
        activities: section.activities?.map((activity: any) => ({
          activity_id: activity.activity_id,
          type: activity.type,
          title: activity.title,
          questions: activity.questions?.map(convertJsonToStandardQuestion)
        })) || []
      })) || [],
      additional_materials: module.additional_materials || [],
      resources: module.resources || []
    }));
  } else if (jsonCourse.content && jsonCourse.content.topics) {
    // Fallback to old structure conversion
    course.modules = jsonCourse.content.topics.map((topic: any, topicIndex: number) => ({
      module_id: `mod-${topic.id}`,
      name: topic.title,
      type: 'e-learning' as const,
      sections: [
        {
          section_id: `sec-${topic.id}-1`,
          name: `${topic.title} Content`,
          order: 1,
          delivery_method: 'e-learning' as const,
          activities: topic.lessons?.map((lesson: any, lessonIndex: number) => ({
            activity_id: `act-${topic.id}-${lessonIndex + 1}`,
            type: lesson.type === 'Exercise' ? 'exercise' as const : 'lesson' as const,
            title: lesson.title,
            questions: lesson.questions?.map(convertJsonToStandardQuestion)
          })) || []
        }
      ],
      additional_materials: [],
      resources: []
    }));
  }

  return course;
}; 